<template>
  <div>
    <!-- 头部 -->
    <div class="new_top">
      <header2></header2>
      <navigation></navigation>
    </div>
    <div class="new_content">
      <div class="new_jpkc_erji">
        <div class="new_yxdt">
          <div class="new_yxdt_tab">
            <ul id="new_yxdt_tab_all">
              <li><a href="javascript:;" @click="init(6)" :class="{ new_yxdt_tab_sel: switchTag===6 }">前沿动态</a></li>
              <li><a href="javascript:;" @click="init(7)" :class="{ new_yxdt_tab_sel: switchTag===7 }">医事经纬</a></li>
              <li><a href="javascript:;" @click="init(8)" :class="{ new_yxdt_tab_sel: switchTag===8 }">病例讨论</a></li>
              <li><a href="javascript:;" @click="init(9)" :class="{ new_yxdt_tab_sel: switchTag===9 }">行业信息</a></li>
              <li><a href="javascript:;" @click="init(12)" :class="{ new_yxdt_tab_sel: switchTag===12 }">学术会议</a></li>
            </ul>
          </div>
          <div class="new_jpkc_list" style="padding-left:15px;border-left:1px #ccc solid;" v-loading="loading" id="kc6">
            <div class="njl1" v-for="item in newsList">
              <div class="njl_pic"><router-link :to="{ path: '/newsInfo', query: { id: item.id }}" target="_blank"><img :src="item.image" /></router-link></div>
              <router-link :to="{ path: '/newsInfo', query: { id: item.id }}" target="_blank" class="njl_text">
                <span class="njl_title textover">{{item.newsTitle}}</span>
                <span class="njl_intro">{{item.description}}</span>
                <span class="njl_speaker">{{item.publishTime}}</span>
              </router-link>
            </div>
          </div>
          <div class="new_num_list" id="coursePageUl6">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="pageNum"
              :page-size="pageSize"
              layout="prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <footer1></footer1>
  </div>
</template>

<script>
  import {listNews} from '../api/api';
  import  header2 from '../components/Header2'
  import  navigation from '../components/Navigation'
  import  footer1 from '../components/Footer1'
  export default {
    components: {
      header2,
      footer1,
      navigation
    },
    data () {
      return {
        switchTag: this.$route.query.switchTag?parseInt(this.$route.query.switchTag):6,
        projectIdsC:(this.$route.query.projectIdsC&&this.$route.query.projectIdsC.length>0)?new Array(this.$route.query.projectIdsC):[],
        newsList: [],
        pageNum: 1,
        pageSize: 10,
        total: 0,
        loading:false
      }
    },
    mounted () {
      this.init()
    },
    computed: {},
    methods: {
      init(switchTag){
        if (switchTag) {
          this.switchTag = switchTag
        }
        this.loading=true;
        listNews({
          consultId: this.switchTag,
          publishState: 0,
          publishTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
          'displayPositionIds': [1, 3],
          'notProjectIds': [8, 9],
          'projectIdsC': this.projectIdsC,
          'orderWeight': true,
          orderPublishTime: true,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }).then((response) => {
          this.newsList = response.data.data.list;
          this.consultName = response.data.data.consultName;
          this.total = response.data.data.total;
          this.loading=false;
        })
      },
      handleCurrentChange(val) {
        this.pageNum = val;
        this.init();
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/MedicalDynamicNewsList.vue